module.exports = __webpack_public_path__ + "img/harrybox-yuri.a86fd1d8.png";